import {
    GOOGLE_OTP_QUARANTINED_SET_LOADING,
    GOOGLE_OTP_QUARANTINED_SET_LIST,
} from '../const';

const initialState = {
    list: [],
    loading: true
};

const handlers = {
    [GOOGLE_OTP_QUARANTINED_SET_LOADING]: (state, {payload}) => ({...state, loading: payload}),
    [GOOGLE_OTP_QUARANTINED_SET_LIST]: (state, {payload: {list}}) => ({
        ...state,
        list: list,
        loading: false
    }),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
}